/**
 * 配置接口请求地址
 */

const URL = {
  login: "pda/auth/login", // 登录
  getWarehouseList: "pda/warehouse/findList", // 会员绑定的仓库列表
  getInboundApplyList: "pda/inboundApply/findPage", // 入库单列表
  getInboundDetailPage: "pda/inboundDetail/findPage", // 入库单明细 (国际条码搜索)
  getReceivingDetailPage: "pda/receivingDetail/findPage", // 分页查询收货明细 (已收货)
  updateBand: "pda/inbound/update", // 收货明细维护
  createBand: "pda/inbound/createBand", // 收货明细新增
  deleteBand: "pda/inbound/delete", // 收货明细删除
  getStorageLocation: "pda/storageLocation/findStorageLocation", // 库位信息查询
  getBand: "pda/receivingDetail/findByBandSn", // 板位信息查询
  findException: "pda/inbound/findException", //查询收货异常数据
  receiptConfirm: "pda/inbound/receiptConfirm", // 收货确认
  shelvesSubmit: "pda/inbound/shelvesConfirm", // 上架确认
  getPickingList: "pda/picking/findPage", // 获取拣货单列表
  getPickingGroupPage: "pda/picking/findGroupPage", // 拣货明细列表
  bindPickingCart: "pda/picking/bindPickingCart", // 绑定拣货车
  getPickingGoodsDetailList: "pda/picking/findPickingDetailPage", // 拣货明细中的商品明细列表
  padScanPicking: "pda/picking/scanPicking", // 拣货商品明细扫描板号 和 国际码
  pickingConfirm: "pda/picking/pickingConfirm", // 拣货确认
  verifyPickingCart: "/pda/picking/verifyPickingCart", //校验拣货订单是否拣货完成
  getCheckStockList: "pda/checkStock/findPage", // 查询盘点单
  getCheckStockDetail: "pda/checkStock/findById", // 查询盘点单详情
  getCheckStockDetailInfo: "pda/checkStock/findByLocationAreaAndCheckId", // 根据库区和盘点单Id查盘点单盘点明细
  getCheckBanInfo: "pda/checkStock/findByStorageLocAndBandSn", // 根据库位和板号查询 板信息
  saveCheckDetailResult: "pda/checkStock/saveResult", // 盘点明细结果保存
  checkConfirm: "pda/checkStock/confirm", // 盘点确认
  findSlList: "pda/storageLocation/findList", // 库位打印
  printAssetsInfo: "pda/assets/findByCode", //固定资产打印
  findBySlCode: "pda/search/findBySlCode", // 库位查询
  findByBandSn: "pda/search/findByBandSn", // 板号查询
  findByBarCode: "pda/search/findByBarCode", //国际码查询
  findByProductId: "pda/search/findByProductId", // 根据商品Id 查询商品在板情况
  allocateList: "/pda/allocate/findPage", // 调拨列表
  allocateDetail: "/pda/allocate/findDetailPage", // 调拨明细
  allocateGoods: "/pda/allocate/findByDetailId", // 调拨商品
  allocateDetailSub: "/pda/allocate/allocateDetailConfirm", // 调拨明细确认
  allocateSub: "/pda/allocate/padConfirm", //调拨确认
  move: "/pda/stockOp/move",//移位
  findApplyById: '/pda/inbound/findApplyById',//查询入库申请单
  findStock: '/pda/stockInfo/findStock',//库存查询
  findStockDetail: '/pda/stockInfo/findById', //查询库存详情
  findOrderCancelPage: 'pda/wmsOrderCancel/findPage', //查询撤单列表
  findOrderCancelDetailByOrderId: 'pda/wmsOrderCancelDetail/findByOrderId', //查询撤单列表
}

export default URL



// WEBPACK FOOTER //
// ./src/api/service.js